import SaleTransactionSummary from '../../../../property/attribute/SaleTransactionSummary';
import OTM from '../../../../../constants/otm';
import ForSaleTransactionSummary from './ForSaleTransactionSummary';
import ForRentTransactionSummary from './ForRentTransactionSummary';

const MapListingSummary = (props) => {
    switch (props.statusType) {
        case OTM.ALL:
        case OTM.RECENT_SALE:
        case OTM.TENURE:
            return (
                <SaleTransactionSummary
                    sx={props.sx}
                    propertyId={props.propertyId}
                    state={props.state}
                    saleData={props.saleData}
                    isSaleTypeHidden
                    salesList={props.salesList}
                    salesLinkText={props.salesLinkText}
                    undisclosedSalesAccess={props.undisclosedSalesAccess}
                    undisclosedSalesFeature={props.undisclosedSalesFeature}
                    getTransactionType={props.getTransactionType}
                    page={props.page}
                    searchType={props.searchType}
                    searchTab={props.searchTab}
                    resultView={props.resultView}
                    searchString={props.searchString}
                />
            );
        case OTM.FOR_SALE:
        case OTM.AGED:
        case OTM.WITHDRAWN:
            return (
                <ForSaleTransactionSummary
                    sx={props.sx}
                    listingDate={props.listingDate}
                    listingPrice={props.listingPrice}
                />
            )
        case OTM.FOR_RENT:
            return (
                <ForRentTransactionSummary
                    sx={props.sx}
                    rentalDate={props.rentalDate}
                    rentalPrice={props.rentalPrice}
                />
            )
        default:
            return null;
    }
};

export default MapListingSummary;